export const delay = async (timeout = 0) => {
  const handler = new Promise((resolve) => setTimeout(resolve, timeout));

  return await handler;
};
